export default {
  title_one: '¿Eliminar {{count}} modificadores?',
  title_other: '¿Eliminar {{count}} modificadores?',
  description: '<strong>{{items}}</strong> se eliminarán del menú',
  buttons: {
    yes: 'Sí',
    no: 'No',
  },
  toasts: {
    failed_to_delete_modifier_one: 'Error al eliminar el modificador',
    failed_to_delete_modifier_other: 'Error al eliminar los modificadores',
    modifiers_got_deleted_one: 'Modificador eliminado',
    modifiers_got_deleted_other: 'Modificadores eliminados',
  },
};
